export class CittadinoDTO {
  nome: string;

  cognome: string;

  cf: string;
}
